<template>
  <div
    style="margin-left: 15px"
    class="mune_box"
  >
    <div class="tabList">
      <div
        v-for="item in topNavData"
        :key="item.menuId || item.name"
        :class="['reference', { active: item.menuId == activeCategory.menuId }]"
        @click="tabFn(item)"
      >
        <img
          v-show="item.meta.icon != '#'"
          class="img"
          :src="getMenuIcon(item.meta.icon)"
          alt=""
        >
        {{ proxy.$t('menu.' + item.name) }} <i class="el-icon-arrow-down" />
      </div>
      <el-popover
        v-model:visible="popoverVisible"
        placement="bottom-start"
        :visible-arrow="false"
        popper-class="popper-menu_is"
      >
        <div class="mune_item_box">
          <div class="title_box">
            <div
              v-for="item in visibleMenuList"
              :key="item.tabType"
              class="title_item"
            >
              <div class="item_title">
                <div class="center">
                  {{ item.title }}
                </div>
              </div>
              <div class="menu_box">
                <template
                  v-for="items in item.list"
                  :key="items.menuId || items.name"
                >
                  <div
                    :class="['menu_item', { active: items.menuId == activeCategory.menuId }]"
                    @click="tabFn(items)"
                  >
                    <img
                      class="img"
                      :src="getMenuIcon(items.meta.icon)"
                      alt=""
                    >
                    <div class="menuTitle">
                      {{ proxy.$t('menu.' + items.name) }}
                    </div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="proxy.$t('menu.topNavTip')"
                      placement="top"
                      :disabled="onPositionActiveFn(items) || onActiveshow()"
                    >
                      <svg
                        :class="['position', 'position-icon', { actives: onPositionActiveFn(items) }, { activeshow: onActiveshow() }]"
                        viewBox="0 0 1024 1024"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        @click.stop="onPosition(items)"
                      >
                        <path
                          d="M334.1824 616.0896l73.728 73.728c-72.6016 61.44-178.6368 156.928-200.5504 174.08C151.7056 907.5712 102.4 921.6 102.4 921.6s14.0288-49.2544 57.7024-104.96c17.152-21.9136 112.64-127.8976 174.08-200.5504zM905.9328 315.392l-197.2736-197.3248a53.4016 53.4016 0 1 0-75.6736 75.6224l15.7184 15.7184-288.1536 203.5712L296.7552 349.184a53.4016 53.4016 0 1 0-75.6224 75.6224l378.0096 377.9584a53.4016 53.4016 0 1 0 75.6224-75.6224l-63.6928-63.6928 203.52-288.256 15.7184 15.7184a53.4016 53.4016 0 1 0 75.6224-75.5712z"
                          fill="currentColor"
                        />
                      </svg>
                    </el-tooltip>
                  </div>
                  <div
                    v-if="items.name == 'StoreOperations'"
                    class="second-menu-shortcuts"
                  >
                    <div
                      v-for="child in getSecondMenuShortcuts(items)"
                      :key="child.menuId || child.name"
                      class="second-menu-shortcut"
                      @click.stop="shortcutFn(items, child)"
                    >
                      {{ child.meta?.title }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <template #reference>
          <div :class="['reference', { active: activeFn() }]">
            <svg-icon
              class-name="app-icon"
              icon-class="app"
            />
            {{ activeFn() ? proxy.$t('menu.' + activeCategory.name) : proxy.$t('menu.Business') }}
            <i>
              <el-icon class="el-icon-arrow-down"><ArrowDown /></el-icon>
            </i>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref, type ComponentInternalInstance } from 'vue';
import { useRouter } from 'vue-router';
import { usePermissionStore } from '../../store/modules/permission.ts';

const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const menuIcons = import.meta.glob('../../assets/images/mune/*.png', { eager: true, import: 'default' });
const getMenuIcon = (icon: string) => menuIcons[`../../assets/images/mune/${icon}.png`];
//
// 展示在顶部的类别    品牌默认固定在首页
const topNavData = ref([]);

const menuList = ref([
  {
    title: proxy.$t('menu.SmartStore'),
    list: [],
    tabType: '1',
  },
  {
    title: proxy.$t('menu.AllPhenomena'),
    list: [],
    tabType: '2',
  },
  {
    title: proxy.$t('menu.DataAnalysis'),
    list: [],
    tabType: '3',
  },
]);
const visibleMenuList = computed(() => menuList.value.filter((item) => item.list.length > 0));

// 顶部栏初始数
const visibleNumber = ref<number>(-1);
const permissionStore = usePermissionStore();
const router = useRouter();
const popoverVisible = ref(false);
onMounted(() => {
  topNavData.value = JSON.parse(localStorage.getItem('CommonMenuList'));
  const menuTypeData = permissionStore.getSidebarRoutesData().filter((v) => {
    return v.menuType == 'S';
  });
  // 1. 把 menuList 转成 Map，方便按 tabType 查找
  const tabTypeMap = new Map(menuList.value.map((item) => [item.tabType, item]));
  // 2. 遍历数据源，按 tabType 分组
  menuTypeData.forEach((item) => {
    if (item.menuId == '1') {
      console.log(' topNavData.value');
      if (!topNavData.value) {
        topNavData.value = [];
      }
      if (topNavData.value.length == 0) {
        // 默认选择   加入固定 品牌
        topNavData.value.unshift(item);
      }
    }
    const target = tabTypeMap.get(item.tagType);

    if (target) {
      target.list.push(item); // 把当前项放进对应的 list 里
    }
  });
});
// 选择类别
const tabFn = (item) => {
  permissionStore.setActiveCategory(item);
  popoverVisible.value = false;
  permissionStore.setSidebarRouters(1);
};
const getSecondMenuShortcuts = (item) => {
  return (item.children || []).filter((child) => !child.hidden && child.menuType !== 'F');
};
const normalizeMenuPath = (parentPath = '', path = '') => {
  const currentPath = path.startsWith('/') ? path : `/${path}`;
  let fullParentPath = '';
  if (parentPath) {
    fullParentPath = parentPath.startsWith('/') ? parentPath : `/${parentPath}`;
  }
  if (fullParentPath && currentPath.startsWith(`${fullParentPath}/`)) {
    return currentPath;
  }
  return `${fullParentPath}${currentPath}`.replace(/\/+/g, '/');
};
const findFirstMenuWithPath = (menuNodes = [], parentPath = '') => {
  for (const node of menuNodes) {
    if (node.hidden || node.menuType === 'F') {
      continue;
    }

    const currentPath = normalizeMenuPath(parentPath, node.path || '');
    if (node.menuType === 'C') {
      return currentPath;
    }
    if (node.children?.length) {
      const childPath = findFirstMenuWithPath(node.children, currentPath);
      if (childPath) {
        return childPath;
      }
    }
  }
  return '';
};
const shortcutFn = (parent, child) => {
  permissionStore.setActiveCategory(parent);
  permissionStore.setSidebarRouters(2);
  popoverVisible.value = false;
  const path = findFirstMenuWithPath([child], parent.path);
  if (path) {
    router.push(path);
  }
};
// 默认激活类别
const activeCategory = computed(() => {
  return permissionStore.getActiveCategory();
});
// 添加  删除固定
const onPosition = (item) => {
  if (
    topNavData.value.filter((v) => {
      return v.menuId == item.menuId;
    }).length == 0
  ) {
    // 不存在  添加
    topNavData.value.push(item);
  } else {
    // 存在删除
    topNavData.value = topNavData.value.filter((v) => {
      return v.menuId != item.menuId;
    });
  }
  localStorage.setItem('CommonMenuList', JSON.stringify(topNavData.value));
};
//
const onActiveshow = () => {
  return topNavData.value.length > 3;
};
// 是否固定
const onPositionActiveFn = (item) => {
  return (
    topNavData.value.filter((v) => {
      return v.menuId == item.menuId;
    }).length > 0
  );
};
// 默认列表固定
const activeFn = () => {
  return (
    topNavData.value.filter((v) => {
      return v.menuId == activeCategory.value.menuId;
    }).length == 0 && activeCategory.value.menuId
  );
};

const setVisibleNumber = () => {
  const width = document.body.getBoundingClientRect().width / 3;
  visibleNumber.value = parseInt(String(width / 85));
};

//
onBeforeUnmount(() => {
  window.removeEventListener('resize', setVisibleNumber);
});

// onMounted(() => {
//   setVisibleNumber();
// });
</script>

<style lang="scss" scoped>
.img {
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
  margin-right: 5px;
}
.mune_box {
  display: flex;
  .tabList {
    display: flex;
  }
  .reference {
    padding: 0 20px;
    height: 60px;
    line-height: 62px;
    margin-top: 4px;
    border-radius: 8px 8px 0 0;
    font-size: 16px;
    min-width: 120px;
    color: #1a1a1a;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    text-align: center;
    &.active {
      background: #f0f3f9;
      color: var(--color-1);
    }

    :deep(.app-icon) {
      width: 18px;
      height: 18px;
      position: relative;
      top: 2px;
    }

    .el-icon-arrow-down {
      font-weight: 600;
      font-size: 14px;
    }
    &:hover {
      .el-icon-arrow-down {
        transform: rotate(180deg);
        transition: transform 0.5s ease;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
}

.mune_item_box {
  padding: 0 10px;
}

.title_box {
  display: flex;
  font-size: 14px;

  .title_item {
    margin-right: 40px;

    .item_title {
      line-height: 30px;
      color: #8d8d8d;

      padding: 0 10px;

      .center {
        border-bottom: #e6e6e6 solid 1px;
      }
    }

    .menu_box {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      max-height: 360px;
      .menu_item {
        color: #333;
        line-height: 34px;
        padding: 0 10px;
        padding-inline-end: 20px;
        position: relative;
        margin-top: 10px;
        border-radius: 4px;
        cursor: pointer;

        .img {
          width: 20px;
          height: 20px;
          position: relative;
          top: 7px;
          margin-right: 5px;
        }

        &:hover {
          background: #f5f5f5;
          .position {
            opacity: 1;
          }
        }
        .position {
          position: absolute;
          inset-inline-end: 3px;
          opacity: 0;
          margin-top: 10px;
          margin-inline-start: 3px;
          color: #999;
          &.actives {
            color: var(--color-1) !important;
            opacity: 1 !important;
          }
          &.activeshow {
            opacity: 0;
          }
        }
        .position-icon {
          width: 14px;
          height: 14px;
        }
      }
      .second-menu-shortcuts {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
        width: 260px;
        margin-top: 8px;
        margin-bottom: 6px;
      }
      .second-menu-shortcut {
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #333;
        background: #f5f7fa;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          background: var(--bg-1);
          color: var(--color-1);
        }
      }

      .active {
        background: var(--bg-1) !important;
        color: var(--color-1) !important;
        font-weight: 600;
      }
    }
  }
}

.topmenu-container.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 50px !important;
  line-height: 50px !important;
  color: #999093 !important;
  padding: 0 5px !important;
  margin: 0 10px !important;
}

.topmenu-container.el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #{'var(--theme)'} !important;
  color: #303133;
}

/* submenu item */
.topmenu-container.el-menu--horizontal > .el-submenu .el-submenu__title {
  float: left;
  height: 50px !important;
  line-height: 50px !important;
  color: #999093 !important;
  padding: 0 5px !important;
  margin: 0 10px !important;
}

.menu_item {
  display: flex;
  // justify-content: space-between;
}

.menutitle {
  width: 100px;
}
</style>

<style lang="scss">
.popper-menu_is {
  width: auto !important;
  border-radius: 8px;
}
</style>
